import './src/styles/global.css';
import { inject } from '@vercel/analytics';

// Initialize Vercel Web Analytics
inject();
